var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage-header_content"},[_c('div',{staticClass:"hide_on_mobile"},[_c('PcSwiper',{attrs:{"company-id":_vm.companyId,"img-list":_vm.imgList}})],1),_vm._v(" "),_c('div',{staticClass:"hide_on_pc"},[_c('MobileSwiper',{attrs:{"company-id":_vm.companyId,"img-list":_vm.imgList}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }